module.exports = __webpack_public_path__ + "static/media/intax.8a64ede4.png";